import React, { useEffect, useState } from "react";
import { Button, OverlayTrigger } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import useFinalizeStatusPoller from "../../../../core/hooks/useFinalizeStatusPoller";
import { AiOutlineDelete } from "react-icons/ai";
import { BiChevronDown, BiChevronRight, BiGridVertical, BiPlusCircle, BiTransfer, BiTrash } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { LS_AUTHORITY_KEY, USER_ROLE } from "../../../../core/constants/common";
import ESGDataSetService from "../../../../core/service/ESGDataSetService";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import StandardService from "../../../../core/service/StandardService";
import PermissionUtils from "../../../../core/utilities/PermissisonUtils";
import LinkDataSource from "../../RiskSettings/LinkDataSource/LinkDataSource";
import "../DataPoints/DataPoints.scss";
import "./QualitativeQuestionsView.scss";
import DataSourceLinker from "../../Datasource/DataSourceLinker";
import LanguageSelectorService from "../../../../core/service/LanguageSelectorService";
import Utils from "../../../../core/utilities/Utils";
import QuestionService from "../../../../core/service/QuestionService";
import FinalizeProgressLoader from "../../../../components/FinalizeProgressLoader/FinalizeProgressLoader";

const QualitativeQuestionsView = ({
  t,
  forESGDataSet = false
}) => {
  const { isFinalizeInProgress } = useFinalizeStatusPoller();
  const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const [primaryLanguageCode, setPrimaryLanguageCode] = useState('');
  const { std_id } = useParams();
  const { topic_id } = useParams();
  const { metric_id } = useParams();
  const navigate = useNavigate();
  const [questionToLink, setQuestiontoLink] = useState({ id: 0 });
  const [metric, setMetric] = useState({
    id: '',
    code: '',
    name: '',
    unitOfMeasure: '',
    category: '',
    relevantUoms: [],
    dataPointUnitBased: false,
    internalCode: '',
    value: '',
    periodic: false,
  });
  const [question, setQuestion] = useState({
    question: "",
    helpText: "",
    sampleAnswer: "",
    code: "",
    children: [],
    singleAnswer: true
  });
  const [validated, setValidated] = useState(false);
  const localizationContent = {
    fieldName: "",
    languageCode: '',
    question: "",
    help_text: "",
    sample_answer: ""
  }

  const [newSubQData, setNewSubQData] = useState();
  const [isLanguageAvailable,setIsLanguageAvailable] = useState(false);
  const [draggedSubQIndex, setDraggedSubQIndex] = useState(null);
  const [dragOverSubQIndex, setDragOverSubQIndex] = useState(null);
  useEffect(() => {
    // loadLanguages();
    let lsLangAvailable = localStorage.getItem('languageAvailable');
      if(lsLangAvailable) {
        setIsLanguageAvailable(JSON.parse(lsLangAvailable));
      } 
    setNewSubQData([{ localizationData: [localizationContent] }]);
    getMetric(metric_id);
  }, [metric_id]);


  const [newData, setNewData] = useState([localizationContent]);
  const [languageOptions, setLanguageOptions] = useState([]);

  const loadLanguages = (metricData) => {
    LanguageSelectorService.getLanguages().then(res => {
      if(res.data && res.data.length>0) {
        setIsLanguageAvailable(true);
        localStorage.setItem('languageAvailable',true);
      }
      
      setLanguageOptions(res.data);
      const primaryCode = res.data
        .filter(language => language.primary)
        .map(language => language.code)[0];
      setPrimaryLanguageCode(primaryCode);
      if (metricData.localizedContents && metricData.localizedContents.length > 0) {
        // Group, transform, and map the translation data
        const groupedByLanguage = groupByLanguage(metricData.localizedContents);
        const customArray = transformGroupedData(groupedByLanguage);
        const mappedData = mapToStateFormat(customArray,primaryCode);        
        setNewData(mappedData);
      } else if(metricData) {
        const localDatContent = {
          fieldName: "",
          languageCode: '',
          question: "",
          help_text: "",
          sample_answer: ""
        };
        localDatContent.question = metricData.question;
        localDatContent.help_text = metricData.helpText;
        localDatContent.sample_answer = metricData.sampleAnswer;
        localDatContent.languageCode = primaryCode;
        setNewData([localDatContent]);
      } else{
        setNewData(prevData =>
          prevData.map(item => ({
            ...item,
            languageCode: primaryCode
          }))
        );
      }
      localizationContent.languageCode = primaryCode;
      if (metricData.children.length <= 0) {
        setNewSubQData([{ localizationData: [localizationContent] }]);
      } else {
        const languages = getLanguageCodes(metricData);
        const transformedData = transformChildren(metricData.children, languages,primaryCode);
        // Check if any localizationData is empty
        const updatedData = transformedData.map(item => {
          if (item.localizationData.length === 0) {
            item.localizationData.push(localizationContent);
          }
          return item;
        });
        setNewSubQData(updatedData);

      }

    }).catch(error => {
      // setLoaderDisplay(false);
    });
  }


  const getLanguageCodes = (data) => {
    const languageCodes = new Set();

    // Collect language codes from localizedContents of each child
    data.children.forEach(child => {
      child.localizedContents.forEach(content => {
        languageCodes.add(content.languageCode);
      });
    });

    // Add language codes from main localizedContents
    data.localizedContents.forEach(content => {
      languageCodes.add(content.languageCode);
    });

    return Array.from(languageCodes);
  };

  // Transform the children array
  const transformChildren = (children, languages,primaryCode) => {   
    return children.map(child => {
      if (languages.length === 0) {
        // If languages array is empty, return the values from child as localization data
        return {
          localizationData: [{
            fieldName: child.fieldName || "",
            languageCode: 'en',
            question: child.question || "",
            help_text: child.helpText || "",
            sample_answer: child.sampleAnswer || "",
          }]
        };
      }
    
      const localizationData = languages
        .filter(language => 
          // Check if the current language exists in the localizedContents of the child
          child.localizedContents.some(item => item.languageCode === language)
        )
        .map(language => {
          const localizedFields = {
            fieldName: "",
            languageCode: language,
            question: child.localizedContents.find(item => item.fieldName === "question" && item.languageCode === language)?.translatedValue || "",
            help_text: child.localizedContents.find(item => item.fieldName === "help_text" && item.languageCode === language)?.translatedValue || "",
            sample_answer: child.localizedContents.find(item => item.fieldName === "sample_answer" && item.languageCode === language)?.translatedValue || "",
          };
          return localizedFields;
        });
    
      // Check if there is no object with primary languageCode
      if (!localizationData.some(item => item.languageCode === primaryCode) && localizationData.length > 0) {
        // Set the languageCode of the first object to primaryCode
        localizationData[0].languageCode = primaryCode;
      }

      localizationData.sort((a, b) => {
        if (a.languageCode === primaryCode) return -1;
        if (b.languageCode === primaryCode) return 1;
        return 0;
      });
    
      return {
        localizationData: localizationData
      };
    });
    
  };




  const getMetric = (mId) => {
    let req;
    if (forESGDataSet) {
      req = ESGDataSetService.getMetric(mId, topic_id);
    } else {
      req = StandardService.getMetricDetails(mId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    }
    req.then((response) => {
      const metricRes = forESGDataSet ? response.data.data[0] : response.data;
      setMetric({
        id: metricRes?.id,
        code: metricRes?.code,
        name: metricRes?.name,
        unitOfMeasure: metricRes?.unitOfMeasure,
        category: metricRes?.category,
        relevantUoms: metricRes?.relevantUoms ?? [],
        dataPointUnitBased: metricRes?.dataPointUnitBased ?? false,
        internalCode: metricRes?.internalCode ?? '',
        value: metricRes?.value ?? '',
        periodic: metricRes?.periodic,
      });
      loadLanguages(metricRes?.question);

      setQuestion(metricRes?.question ?? null);
    }).catch((error) => { });
  };

  // Function to group items by language
  const groupByLanguage = (items) => {
    return items.reduce((acc, item) => {
      const { languageCode } = item;
      if (!acc[languageCode]) acc[languageCode] = [];
      acc[languageCode].push(item);
      return acc;
    }, {});
  };


  const transformGroupedData = (groupedData) => {
    return Object.keys(groupedData).map((language) => {
      const translations = groupedData[language].reduce((acc, item) => {
        acc[item.fieldName] = item.translatedValue;
        return acc;
      }, {});

      return {
        language,
        translations,
      };
    });
  };

  const mapToStateFormat = (customArray,primaryCode) => {
    const result = customArray
      .map((item) => ({
        fieldName: "",
        languageCode: item.language,
        question: item.translations.question,
        help_text: item.translations.help_text,
        sample_answer: item.translations.sample_answer,
      }));

    // Check if there is no object with primaryCode
    if (!result.some(item => item.languageCode === primaryCode) && result.length > 0) {
      result[0].languageCode = primaryCode;
    }

    // Sort result
    const sortedResult = result.sort((a, b) => {
      if (a.languageCode === primaryCode) return -1;
      if (b.languageCode === primaryCode) return 1;
      return 0;
    });

    return sortedResult;

  };


  const breadCrumbClick = (url) => {
    let urlMain = '';
    // if (PermissionUtils.isCompanyAdmin(authority.roles) || PermissionUtils.isConsultant(authority.roles)) {
    //   urlMain = '/company_admin' + url
    // } else {
    //   urlMain = '/admin' + url
    // }
    if(PermissionUtils.isSuperAdmin(authority.roles)){
      urlMain = '/admin' + url
    }else{
      urlMain = '/company_admin' + url
    }
    navigate(urlMain);
  }

  const handleDataSourceLink = (questionId, dataSourceId = "") => {
    //console.log(questionId);
    setQuestiontoLink({
      id: questionId,
      dataSourceId: dataSourceId
    });
  };

  const handleDataSourceUnlink = (item) => {
    RiskConfigService.unlinkDatasource(std_id, item.id, 'metric-question')
      .then((response) => {
        if (response.status === 200) {
          toast.success(t("Success.label"), {
            position: toast.POSITION.TOP_RIGHT,
          });
          getMetric(metric_id);
        }
      }).catch((error) => { });
  };

  const handleDataSourceCallback = (val) => {
    setQuestiontoLink({ id: 0 });
    getMetric(metric_id);
  };


  const saveData = (e) => {
  
    const localizedArray = [];
    
    if (!metric.id || !metric.category || !metric.name) return;

    const hasEmptyRequired = (list) => list?.some(i => !i.question?.trim() || !i.help_text?.trim());
    if (question && (hasEmptyRequired(newData)
      || (question.children?.length > 0 && newSubQData.some(s => hasEmptyRequired(s.localizationData))))) {
      setValidated(true);
      return;
    }

    let params = {
      ...metric,
      question: question

    };

    if(isLanguageAvailable) {
      
      newData.forEach((item, index) => {
        const objqstn = {
          "fieldName": "question",
          "languageCode": item.languageCode,
          "translatedValue": item.question
        };
        const objhelptxt = {
          "fieldName": "help_text",
          "languageCode": item.languageCode,
          "translatedValue": item.help_text
        };
        const objsample = {
          "fieldName": "sample_answer",
          "languageCode": item.languageCode,
          "translatedValue": item.sample_answer
        };
        localizedArray.push(objqstn, objhelptxt, objsample);
  
      });
  
  
      // Transform the data and flatten the localizationData into a single array for each entry
      const transformedData = newSubQData.map(item =>
        item.localizationData.flatMap(locale => [
          {
            fieldName: "question",
            languageCode: locale.languageCode,
            translatedValue: locale.question
          },
          {
            fieldName: "help_text",
            languageCode: locale.languageCode,
            translatedValue: locale.help_text
          },
          {
            fieldName: "sample_answer",
            languageCode: locale.languageCode,
            translatedValue: locale.sample_answer
          }
        ])
      );
      params.question['localizedContents'] = localizedArray;
    if (params.question.children.length > 0) {
      params.question.children = params.question.children.map((item, index) => ({
        ...item,
        localizedContents: transformedData[index] || []
      }));

      params.question.children.forEach(item => {       
        item.localizedContents.forEach(content => {
          if (content.languageCode === primaryLanguageCode) {
            if (content.fieldName === 'question') {
              item.question = content.translatedValue;
            } else if (content.fieldName === 'help_text') {
              item.helpText = content.translatedValue;
            } else if (content.fieldName === 'sample_answer') {
              item.sampleAnswer = content.translatedValue;
            }
          }
        });
      });
    }

    const localized = params.question.localizedContents;
    // Find and set the translations for 'question', 'help_text', and 'sample_answer' with primary language code
    localized.forEach(content => {
      if (content.languageCode === primaryLanguageCode) {
        if (content.fieldName === 'question') {
          params.question.question = content.translatedValue;
        } else if (content.fieldName === 'help_text') {
          params.question.helpText = content.translatedValue;
        } else if (content.fieldName === 'sample_answer') {
          params.question.sampleAnswer = content.translatedValue;
        }
      }
    });
    } else {
      const subQData = [...newSubQData];
      params.question.children.forEach((child, index) => {
        const localData = subQData[index]?.localizationData[0]; 
        if (localData) {
          child.question = localData.question;
          child.helpText = localData.help_text;
          child.sampleAnswer = localData.sample_answer;
        }
      });
  
      // Map values to the main question object
      const qData = newData[0]; 
      if (qData) {
        params.question.question = qData.question;
        params.question.helpText = qData.help_text;
        params.question.sampleAnswer = qData.sample_answer;
      }
    }

    let req;
    if (forESGDataSet) {
      params.active = true;
      params.mandatory = false;
      req = ESGDataSetService.updateMetric(params);
    } else {
      req = StandardService.editMetric(params, metric.id, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    }
    req.then((response) => {
      if (response.status === 200) {
        toast.success(t("Success.label"), {
          position: toast.POSITION.TOP_RIGHT,
        });
        setValidated(false);
        getMetric(metric_id);
      }
    }).catch((error) => { });
    setValidated(true);
  };

  const handleLocalizationChange = (index, field, value) => {
    const updatedItems = [...newData];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value
    };
    setNewData(updatedItems);
  };

  const handleSubQLocalizationChange = (qIndex, index, field, value) => {
    const dataSQ = newSubQData;
    const updatedItems = [...dataSQ[qIndex].localizationData];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value
    };


    const updatedDataSQ = [
      ...dataSQ.slice(0, qIndex),
      {
        ...dataSQ[qIndex],
        localizationData: updatedItems,
      },
      ...dataSQ.slice(qIndex + 1),
    ];
    setNewSubQData(updatedDataSQ);
  };

  const getAvailableOptions = (type, code, qIndex) => {
    let dataChoosed = [];
    switch (type) {
      case t("Question.label"): dataChoosed = newData;
        break;
      case t("SubQuestion.label"): dataChoosed = newSubQData[qIndex].localizationData;
        break;

      default:
        break;
    }
    const selectedValues = dataChoosed.map(row => row.languageCode).filter(Boolean);

    const filtered = languageOptions.filter(
      option => {
        return !selectedValues.includes(option.code) ||
          dataChoosed.find(row => row.languageCode === code)?.languageCode === option.code
      }

    );

    return filtered;
  };

  const addLocalizationRow = (type, qIndex) => {
    switch (type) {
      case t("Question.label"): setNewData(prevItems => [...prevItems, localizationContent]);
        break;
      case t("SubQuestion.label"): {

        setNewSubQData((prevItems) => {
          const updatedItems = [...prevItems];
          updatedItems[qIndex] = {
            ...updatedItems[qIndex],
            localizationData: [
              ...updatedItems[qIndex].localizationData,
              localizationContent,
            ],
          };
          return updatedItems;
        });

      }
        break;

      default:
        break;
    }

  };

  const handleTranslate = (type, targetLang, index, qIndex) => {
    var mainObj = {};
    const isQuestion = checkIsQuestion(type);
    if (isQuestion) {
      mainObj = newData[0];
    } else {
      mainObj = newSubQData[qIndex].localizationData[0];
    }
    const sourceLang = mainObj.languageCode;
    const textArray = [];
    textArray.push(mainObj.question);
    textArray.push(mainObj.help_text);
    textArray.push(mainObj.sample_answer);
    if (textArray.length >0 
      && sourceLang != null && sourceLang != ''
      && targetLang != null && targetLang != '') {
      QuestionService.translateText(textArray, sourceLang, targetLang).then(res => {
        if (res.status !== 200) return;
        const result = res.data.translations;
        if (isQuestion) {
          const updatedItems = [...newData];
          updatedItems[index] = {
            ...updatedItems[index],
            question: result[0]?.text,
            help_text: result[1]?.text,
            sample_answer: result[2]?.text,
          };
          setNewData(updatedItems);
        } else {
          const updatedItems = [...newSubQData[qIndex].localizationData];
          updatedItems[index] = {
            ...updatedItems[index],
            question: result[0]?.text,
            help_text: result[1]?.text,
            sample_answer: result[2]?.text,
          };

          const updatedSubQData = [
            ...newSubQData.slice(0, qIndex),
            {
              ...newSubQData[qIndex],
              localizationData: updatedItems,
            },
            ...newSubQData.slice(qIndex + 1),
          ];
          setNewSubQData(updatedSubQData);

        }

      }).catch(err => { });
    } else {
      let message = '';
      if (sourceLang == '') {
        message = t("ProvideSourceMsg.label");
      } else if (targetLang == '') {
        message = t("ProvideTargetMsg.label");
      } else if (textArray.length >0 ) {
        message = t("ProvideTextMsg.label");
      }
      toast.warning(message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

  }

  const checkIsQuestion = (type) => {
    let isQuestion = false;
    if (t('Question.label') == type) {
      isQuestion = true;
    }
    return isQuestion;
  }

  const deleteLocalization = (qIndex, index, type) => {
    if (checkIsQuestion(type)) {
      const filtered = newData.filter((_, i) => i !== index);
      setNewData(filtered);
    } else {
      const filteredLocalizationData = newSubQData[qIndex].localizationData.filter((_, i) => i !== index);

      // Create a new array for newSubQData with the updated localizationData at qIndex
      const updatedSubQData = [
        ...newSubQData.slice(0, qIndex),
        {
          ...newSubQData[qIndex],
          localizationData: filteredLocalizationData,
        },
        ...newSubQData.slice(qIndex + 1),
      ];

      setNewSubQData(updatedSubQData);

    }

  };

  const deleteMainQuestion = () => {
    setQuestion(null);
    setNewSubQData([{ localizationData: [localizationContent] }]);
    setNewData([localizationContent]);
  }

  const renderQuestionFields = () => {
    if (!question) {
      return (
        <a className={`text-primary cursor mx-2 ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
          if (isFinalizeInProgress) return;
          onAddQuestion();
        }}>
          <Button variant="outline-primary" disabled={isFinalizeInProgress}><BiPlusCircle className="me-2"></BiPlusCircle>{t('AddQuestion.label')}</Button>
        </a>
      );
    }


    return (
      <>
        <div className="card p-0 m-2">
          <div className="card-header">
            <span className="float-left">{t('Question.label')}</span>
            <span className="float-right">
              <ul className="d-flex align-items-center ms-2 my-0 list-unstyled ">
                <DataSourceLinker item={question}
                  openDataSourceLink={(itemId, dataSourceId) => {
                    if (isFinalizeInProgress) return;
                    handleDataSourceLink(question.id, dataSourceId);
                  }}
                  unlinkDataSource={(item) => {
                    if (isFinalizeInProgress) return;
                    handleDataSourceUnlink(item);
                  }}
                  disabled={isFinalizeInProgress} />
              </ul>
            </span>
            <span className={`float-right cursor ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
              if (isFinalizeInProgress) return;
              deleteMainQuestion();
            }}><AiOutlineDelete /></span>
          </div>
          <div className="card-body">

            {newData.map((item, index) => (
              <div className="row qualquestions-field-row" key={`q-lang-${index}`}>
                {isLanguageAvailable && <div className="col-12 col-md-6 col-lg-2 p-2">
                  <label className='mb-1'>{t("Language.label")} <span>*</span></label>
                  <select className="form-select form-select-sm" value={item.languageCode}
                    disabled={item.languageCode == primaryLanguageCode}
                    onChange={(e) => handleLocalizationChange(index, "languageCode", e.target.value)}>
                    <option value="">Select a language</option>
                    {getAvailableOptions(t("Question.label"), item.languageCode, null).map(option => (
                      <option value={option.code} key={option.code}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>}
                <div className="col-12 col-md-6 col-lg-3 p-2">
                  <label className="mb-1">{t("Question.label")} <span className="text-danger">*</span></label>
                  <textarea
                    rows='5'
                    className={`form-control${isFieldInvalid(item.question) ? ' is-invalid' : ''}`}
                    value={item.question}
                    onChange={(e) => handleLocalizationChange(index, "question", e.target.value)}
                    required>
                  </textarea>
                </div>
                <div className="col-12 col-md-6 col-lg-3 p-2">
                  <label className="mb-1">{t("HelpText.label")} <span className="text-danger">*</span></label>
                  <textarea
                    rows='5'
                    className={`form-control${isFieldInvalid(item.help_text) ? ' is-invalid' : ''}`}
                    value={item.help_text}
                    onChange={(e) => handleLocalizationChange(index, "help_text", e.target.value)}
                    required>
                  </textarea>
                </div>
                <div className="col-12 col-md-6 col-lg-3 p-2">
                  <label className="mb-1">{t("SampleAnswer.label")}</label>
                  <textarea
                    rows='5'
                    className="form-control"
                    value={item.sample_answer}
                    onChange={(e) => handleLocalizationChange(index, "sample_answer", e.target.value)}>
                  </textarea>
                </div>
                <div className="col-12 col-lg-1 p-2 d-flex align-items-center justify-content-start justify-content-lg-center">
                  <ul className='stakeCat_add mb-0'>
                    {
                      (index > 0) && (
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            'Click to Translate'
                          )}>
                          <li>
                            <span className={`cursor ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
                              if (isFinalizeInProgress) return;
                              handleTranslate(t("Question.label"), item.languageCode, index, null);
                            }}>
                              <BiTransfer />
                            </span>
                          </li>
                        </OverlayTrigger>
                      )
                    }
                    {
                      (newData.length > 1 && (item.languageCode != primaryLanguageCode)) && (
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            'Delete'
                          )}>
                          <li>
                            <span className={`cursor ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
                              if (isFinalizeInProgress) return;
                              deleteLocalization(null, index, t("Question.label"));
                            }}>
                              <BiTrash />
                            </span>
                          </li>
                        </OverlayTrigger>
                      )}
                    {
                      ((index == newData.length - 1) && newData.length < languageOptions.length) && (
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            'Add new'
                          )}>
                          <li>
                            <Button variant='GroupStake' size="sm" className={`btn-outline-primary border-0 ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
                              if (isFinalizeInProgress) return;
                              addLocalizationRow(t("Question.label"), null);
                            }} disabled={isFinalizeInProgress}> <BiPlusCircle /></Button>
                          </li>
                        </OverlayTrigger>
                      )}
                  </ul>
                </div>
              </div>
            ))}

            <div className="row">
              <div className="col-12 col-md-6 col-lg-4 p-2">
                <label className="mb-1">{t("QuestionCode.label")}</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={question.code}
                  onChange={(e) => setQuestion({ ...question, code: e.target.value })}
                  maxLength={50}
                />
              </div>
              <div className="col-12 p-2">
                <div className="d-flex align-items-center">
                  <input className="form-check-input" type="checkbox"
                    id='singleAnswerCheckbox'
                    checked={question.singleAnswer}
                    onChange={() => setQuestion({ ...question, singleAnswer: !question.singleAnswer })} />
                  <label className="form-check-label mx-1" htmlFor='singleAnswerCheckbox'>
                    {t("SingleAnswer.label")}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        {question.children?.length > 0 && (
          <div className="d-flex align-items-center justify-content-between px-2">
            <h6 className="mb-0">{t('SubQuestions.label')}</h6>
            <div className="sub-question-toggle-all">
              <Button variant="link" size="sm" onClick={() => setAllSubQuestionsCollapsed(false)}>{t('ExpandAll.label')}</Button>
              <Button variant="link" size="sm" onClick={() => setAllSubQuestionsCollapsed(true)}>{t('CollapseAll.label')}</Button>
            </div>
          </div>
        )}
        {
          question.children?.map((child, cIndex) => {
            return renderSubQuestionFields(child, cIndex);
          })
        }
        <div className="col-lg-12 py-1 px-2">
          <a className={`text-primary cursor mx-2 ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
            if (isFinalizeInProgress) return;
            onAddNewSubQuestion();
          }}>
            <Button variant="outline-primary" disabled={isFinalizeInProgress}><BiPlusCircle className="me-2"></BiPlusCircle>{t('AddSubQuestion.label')}</Button>
          </a>
          <a className={`text-primary cursor mx-2 ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
            if (isFinalizeInProgress) return;
            saveData();
          }}>
            <Button variant="primary" disabled={isFinalizeInProgress}>{t('Save.label')}</Button>
          </a>
        </div>
      </>
    );
  };

  const renderSubQuestionFields = (q, qIndex) => {
    return (
      <div className="col-lg-12 py-1 px-2">
        <div
          className={`card 1 SubQuestion_card${isSubQuestionDragTarget(qIndex) ? ' standards-drop-target' : ''}${isSubQuestionDragging(qIndex) ? ' opacity-50' : ''}`}
          id={`subQuestion-${qIndex}`}
          key={`subQuestion-${qIndex}`}
          onDragOver={(e) => canReorderSubQuestions() && draggedSubQIndex !== null && onSubQuestionDragOver(e, qIndex)}
        >
          <div className="card-header sub-question-header">
            <div className="sub-question-header-title">
              <span
                className={`sub-question-drag-handle ${isFinalizeInProgress ? 'disabled-icon' : ''}`}
                draggable={canReorderSubQuestions()}
                onDragStart={(e) => {
                  if (!canReorderSubQuestions()) {
                    e.preventDefault();
                    return;
                  }
                  const card = e.currentTarget.closest('.SubQuestion_card');
                  if (card) e.dataTransfer.setDragImage(card, 0, 0);
                  e.dataTransfer.effectAllowed = 'move';
                  onSubQuestionDragStart(qIndex);
                }}
                onDragEnd={onSubQuestionDragEnd}
              >
                <BiGridVertical />
              </span>
              <button
                type="button"
                className="sub-question-toggle"
                aria-expanded={!isSubQuestionCollapsed(qIndex)}
                onClick={() => toggleSubQuestionCollapsed(qIndex)}
              >
                {isSubQuestionCollapsed(qIndex) ? <BiChevronRight /> : <BiChevronDown />}
                <span className="sub-question-index">{t('SubQuestion.label')} {qIndex + 1}</span>
              </button>
              {isSubQuestionCollapsed(qIndex) && newSubQData[qIndex]?.localizationData[0]?.question && (
                <span className="sub-question-preview" title={newSubQData[qIndex].localizationData[0].question}>
                  {newSubQData[qIndex].localizationData[0].question}
                </span>
              )}
            </div>
            <div className="sub-question-header-actions">
              <ul className="d-flex align-items-center my-0 ps-0 list-unstyled">
                <DataSourceLinker item={q}
                  openDataSourceLink={(itemId, dataSourceId) => {
                    if (isFinalizeInProgress) return;
                    handleDataSourceLink(q.id, dataSourceId);
                  }}
                  unlinkDataSource={(item) => {
                    if (isFinalizeInProgress) return;
                    handleDataSourceUnlink(item);
                  }}
                  disabled={isFinalizeInProgress} />
              </ul>
              <OverlayTrigger
                placement="top"
                overlay={Utils.renderTooltip(t('Delete.label'))}>
                <button
                  type="button"
                  className="sub-question-delete-btn"
                  aria-label={t('Delete.label')}
                  disabled={isFinalizeInProgress}
                  onClick={() => {
                    if (isFinalizeInProgress) return;
                    onDeleteSubQuestion(qIndex);
                  }}
                >
                  <AiOutlineDelete />
                </button>
              </OverlayTrigger>
            </div>
          </div>
          {!isSubQuestionCollapsed(qIndex) && <div className="card-body">
            {newSubQData[qIndex]?.localizationData.map((item, index) => (
              <div className="row qualquestions-field-row" key={`subq-${qIndex}-lang-${index}`}>
                {isLanguageAvailable && <div className="col-12 col-md-6 col-lg-2 p-2">
                  <label className='mb-1'>{t("Language.label")} <span className="text-danger">*</span></label>
                  <select className="form-select form-select-sm" value={item.languageCode}
                    disabled={item.languageCode == primaryLanguageCode}
                    onChange={(e) => handleSubQLocalizationChange(qIndex, index, "languageCode", e.target.value)}>
                    <option value="">Select a language</option>
                    {getAvailableOptions(t("SubQuestion.label"), item.languageCode, qIndex).map(option => (
                      <option value={option.code} key={option.code}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>}
                <div className="col-12 col-md-6 col-lg-3 p-2">
                  <label className="mb-1">{t("Question.label")} <span className="text-danger">*</span></label>
                  <textarea
                    rows='5'
                    className={`form-control${isFieldInvalid(item.question) ? ' is-invalid' : ''}`}
                    value={item.question}
                    onChange={(e) => handleSubQLocalizationChange(qIndex, index, "question", e.target.value)}
                    required>
                  </textarea>
                </div>
                <div className="col-12 col-md-6 col-lg-3 p-2">
                  <label className="mb-1">{t("HelpText.label")} <span className="text-danger">*</span></label>
                  <textarea
                    rows='5'
                    className={`form-control${isFieldInvalid(item.help_text) ? ' is-invalid' : ''}`}
                    value={item.help_text}
                    onChange={(e) => handleSubQLocalizationChange(qIndex, index, "help_text", e.target.value)}
                    required>
                  </textarea>
                </div>
                <div className="col-12 col-md-6 col-lg-3 p-2">
                  <label className="mb-1">{t("SampleAnswer.label")}</label>
                  <textarea
                    rows='5'
                    className="form-control"
                    value={item.sample_answer}
                    onChange={(e) => handleSubQLocalizationChange(qIndex, index, "sample_answer", e.target.value)}>
                  </textarea>
                </div>
                <div className="col-12 col-lg-1 p-2 d-flex align-items-center justify-content-start justify-content-lg-center">
                  <ul className='stakeCat_add mb-0'>
                    {
                      (index > 0) && (
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t('ClickToTranslate.label')
                          )}>
                          <li>
                            <span className={`cursor ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
                              if (isFinalizeInProgress) return;
                              handleTranslate(t("SubQuestion.label"), item.languageCode, index, qIndex);
                            }}>
                              <BiTransfer />
                            </span>
                          </li>
                        </OverlayTrigger>
                      )
                    }
                    {
                      (newSubQData[qIndex]?.localizationData.length > 1 && (item.languageCode != primaryLanguageCode)) && (
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t('Delete.label')
                          )}>
                          <li>
                            <span className={`cursor ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
                              if (isFinalizeInProgress) return;
                              deleteLocalization(qIndex, index, t("SubQuestion.label"));
                            }}>
                              <BiTrash />
                            </span>
                          </li>
                        </OverlayTrigger>
                      )}
                    {
                      ((index == newSubQData[qIndex]?.localizationData.length - 1) && newSubQData[qIndex]?.localizationData.length < languageOptions.length) && (
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t('AddNew.label')
                          )}>
                          <li>
                            <Button variant='GroupStake' size="sm" className={`btn-outline-primary border-0 ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
                              if (isFinalizeInProgress) return;
                              addLocalizationRow(t("SubQuestion.label"), qIndex);
                            }} disabled={isFinalizeInProgress}> <BiPlusCircle /></Button>
                          </li>
                        </OverlayTrigger>
                      )}
                  </ul>
                </div>
              </div>
            ))}

            <div className="row">
              <div className="col-12 col-md-6 col-lg-4 p-2">
                <label className="mb-1">{t("QuestionCode.label")}</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={q.code}
                  onChange={(e) => onSubQuestionCodeChange(qIndex, e.target.value)}
                  maxLength={50}
                />
              </div>
              <div className="col-12 p-2">
                <div className="d-flex align-items-center">
                  <input className="form-check-input" type="checkbox"
                    id={`singleAnswerCheckbox-${qIndex}`}
                    checked={q.singleAnswer}
                    onChange={() => onSubQuestionSingleAnswerChange(qIndex, !q.singleAnswer)} />
                  <label className="form-check-label mx-1" htmlFor={`singleAnswerCheckbox-${qIndex}`}>
                    {t("SingleAnswer.label")}
                  </label>
                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
    );
  };

  const onAddQuestion = () => {
    setQuestion({
      question: "",
      helpText: "",
      sampleAnswer: "",
      code: "",
      children: [],
      singleAnswer: true
    });
  };


  const onAddNewSubQuestion = () => {
    const q = JSON.parse(JSON.stringify(question));
    if (!q.children) {
      q.children = [];
    }
    q.children.push({
      question: "",
      helpText: "",
      sampleAnswer: "",
      code: "",
      singleAnswer: true
    });


    if (q.children.length > 1) {
      localizationContent.languageCode = primaryLanguageCode;
      const updatedNewSubQData = [
        ...newSubQData,
        { localizationData: [localizationContent] }
      ];
      setNewSubQData(updatedNewSubQData);
    }

    setQuestion(q);
  };

  const onDeleteSubQuestion = (qIndex) => {
    const q = JSON.parse(JSON.stringify(question));
    if (q.children[qIndex]) {
      q.children.splice(qIndex, 1);
    }
    setQuestion(q);
    const subq = JSON.parse(JSON.stringify(newSubQData));
    subq?.splice(qIndex, 1);    
    setNewSubQData(subq);
    setCollapsedSubQs(prev => prev.filter((_, idx) => idx !== qIndex));
  };

  const onSubQuestionCodeChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].code = val;
    setQuestion(q);
  };

  const onSubQuestionValChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].question = val;
    setQuestion(q);
  };

  const onSubQuestionHelpTextChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].helpText = val;
    setQuestion(q);
  };

  const onSubQuestionAnswerChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].sampleAnswer = val;
    setQuestion(q);
  };

  const onSubQuestionSingleAnswerChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].singleAnswer = val;
    setQuestion(q);
  };

  const canReorderSubQuestions = () => !isFinalizeInProgress;

  // Removes the dragged item and reinserts it directly after the target item,
  // mirroring the movedToId semantics the reorder API expects.
  const reorderArrayLocally = (arr, draggedIndex, targetIndex) => {
    const moved = arr[draggedIndex];
    const filtered = arr.filter((_, idx) => idx !== draggedIndex);
    const targetFilteredIndex = targetIndex > draggedIndex ? targetIndex - 1 : targetIndex;
    filtered.splice(targetFilteredIndex + 1, 0, moved);
    return filtered;
  };

  const onSubQuestionDragStart = (qIndex) => {
    setDraggedSubQIndex(qIndex);
  };

  const onSubQuestionDragOver = (e, qIndex) => {
    e.preventDefault();
    setDragOverSubQIndex(qIndex);
  };

  const onSubQuestionDragEnd = () => {
    if (draggedSubQIndex === null || dragOverSubQIndex === null || draggedSubQIndex === dragOverSubQIndex) {
      setDraggedSubQIndex(null);
      setDragOverSubQIndex(null);
      return;
    }

    const draggedChildId = question.children[draggedSubQIndex]?.id;
    const targetChildId = question.children[dragOverSubQIndex]?.id;

    const q = JSON.parse(JSON.stringify(question));
    q.children = reorderArrayLocally(q.children, draggedSubQIndex, dragOverSubQIndex);
    setQuestion(q);

    setNewSubQData(prev => reorderArrayLocally(prev, draggedSubQIndex, dragOverSubQIndex));
    setCollapsedSubQs(prev => {
      const flags = question.children.map((_, idx) => !!prev[idx]);
      return reorderArrayLocally(flags, draggedSubQIndex, dragOverSubQIndex);
    });

    // Only persisted sub-questions (real ids) can be reordered server-side;
    // a not-yet-saved sub-question just gets reordered locally until Save.
    if (draggedChildId && targetChildId) {
      StandardService.reorderQuestion(draggedChildId, { movedToId: targetChildId })
        .finally(() => getMetric(metric_id));
    }

    setDraggedSubQIndex(null);
    setDragOverSubQIndex(null);
  };

  const isSubQuestionDragTarget = (qIndex) =>
    canReorderSubQuestions()
    && dragOverSubQIndex === qIndex
    && draggedSubQIndex !== qIndex;

  const isSubQuestionDragging = (qIndex) =>
    canReorderSubQuestions() && draggedSubQIndex === qIndex;


  const [collapsedSubQs, setCollapsedSubQs] = useState([]);

  const isSubQuestionCollapsed = (qIndex) => !!collapsedSubQs[qIndex];

  const toggleSubQuestionCollapsed = (qIndex) => {
    setCollapsedSubQs(prev => {
      const flags = [...prev];
      flags[qIndex] = !flags[qIndex];
      return flags;
    });
  };

  const setAllSubQuestionsCollapsed = (collapsed) => {
    setCollapsedSubQs((question?.children || []).map(() => collapsed));
  };

  const isFieldInvalid = (value) => validated && !value?.trim();

  return (
    <>
      <div className="List_header pb-2">
        <h5 className="MH m-0">{t("Configurations.label")}</h5>
      </div>
      <div className="Topics_headeView">
        <ul>
          <li>
            Standard : <b>{localStorage.getItem('standardName')}</b>
          </li>
          <li>
            Category : <b>{localStorage.getItem('categoryName')}</b>
          </li>
          <li>
            Topic : <b>{localStorage.getItem('topicName')}</b>
          </li>
          <li>
            Metric : <b>{localStorage.getItem('metricName')}</b>
          </li>
        </ul>
        <div className="btn-custom p-1 text-end">
          <button
            className="btn btn-secondary"
            onClick={() => breadCrumbClick('/metriclist/' + std_id + '/' + topic_id)}>
            {t("Back.label")}
          </button>
        </div>
      </div>
      <FinalizeProgressLoader isFinalizeInProgress={isFinalizeInProgress} />
      {
        questionToLink?.id > 0
          ?
          <LinkDataSource
            regulation={std_id}
            paramId={questionToLink.id}
            dsId={questionToLink?.dataSourceId}
            handleDataSourceCallback={handleDataSourceCallback}
            configType={'KPI'}
            paramType={'metric-question'} />
          :
          renderQuestionFields()
      }
    </>
  );
};

export default withTranslation()(QualitativeQuestionsView);
